import { render, staticRenderFns } from "./BulkCompanyUserRoleDialog.vue?vue&type=template&id=2179450d"
import script from "./BulkCompanyUserRoleDialog.vue?vue&type=script&lang=ts"
export * from "./BulkCompanyUserRoleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports